(() => {
  if (window.crosightImpactCodeInstalled) return;
  window.crosightImpactCodeInstalled = true;
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[aria-controls^="crosight-impact-code-"]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog?.matches('[data-crosight-impact-code]') || dialog.open) return;
      dialog.querySelector('[data-impact-code-status]').textContent = '';
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      dialog.addEventListener('close', () => { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }, { once: true });
      return;
    }
    const dialog = event.target.closest('dialog[data-crosight-impact-code]');
    if (!dialog) return;
    if (event.target.closest('[data-impact-code-close]') || event.target === dialog) { dialog.close(); return; }
    const copy = event.target.closest('[data-impact-code-copy]');
    if (!copy) return;
    const value = dialog.querySelector('[data-impact-code-value]');
    const status = dialog.querySelector('[data-impact-code-status]');
    try {
      await navigator.clipboard.writeText(value.value);
      status.textContent = copy.dataset.copiedText;
    } catch {
      value.focus();
      value.select();
      status.textContent = copy.dataset.fallbackText;
    }
  });
})();
